// extracted by mini-css-extract-plugin
export var Checkbox = "Checkbox-module--Checkbox--1NSJS";
export var CheckboxInput = "Checkbox-module--CheckboxInput--17acN";
export var CheckboxLabel = "Checkbox-module--CheckboxLabel--1844e";